var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrollable"},[_c('div',{ref:"scrollableContent",staticClass:"scrollable__content scrollbar"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"scrollable__fade scrollable__fade",class:{ 'scrollable__fade--hide': !_vm.showBottomFade }})])
}
var staticRenderFns = []

export { render, staticRenderFns }